(function () {
  'use strict';

  var MIN  = 25;
  var STEP = 25;
  var _correcting = false;

  function clampToStep(val) {
    if (isNaN(val) || val < MIN) return MIN;
    var rem = val % STEP;
    return rem === 0 ? val : val + (STEP - rem);
  }

  // Call Eurus theme's updatePrice() via Alpine component data
  function triggerUpdatePrice(input) {
    if (!window.Alpine || !Alpine.$data) return;
    try {
      var xDataEl = input && input.closest('[x-data]');
      if (!xDataEl) return;
      var data = Alpine.$data(xDataEl);
      if (data && typeof data.updatePrice === 'function') {
        data.updatePrice();
      }
    } catch (e) {}
  }

  // ── CART DRAWER & CART PAGE ───────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[aria-label="button-minus"],[aria-label="button-plus"]');
    if (!btn) return;

    var container = btn.closest('[data-min25="true"]');
    if (!container) return;

    var input = container.querySelector('input[type="number"]');
    if (!input) return;

    var isMinus = btn.getAttribute('aria-label') === 'button-minus';
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = 0;

    var next;
    if (isMinus) {
      var snapped = current < MIN ? MIN : Math.ceil(current / STEP) * STEP;
      next = Math.max(MIN, snapped - STEP);
    } else {
      if (current < MIN) {
        next = MIN;
      } else {
        var rem = current % STEP;
        next = rem === 0 ? current + STEP : current + (STEP - rem);
      }
    }

    e.stopImmediatePropagation();
    e.preventDefault();

    input.value = next;
    _correcting = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    _correcting = false;

  }, true);

  // Validate direct keyboard/paste input in cart
  document.addEventListener('change', function (e) {
    if (_correcting) return;
    if (!e.target || e.target.tagName !== 'INPUT') return;

    var container = e.target.closest('[data-min25="true"]');
    if (!container) return;

    var val = parseInt(e.target.value, 10);
    var corrected = clampToStep(val);

    if (val !== corrected) {
      e.stopImmediatePropagation();
      e.target.value = corrected;
      _correcting = true;
      e.target.dispatchEvent(new Event('change', { bubbles: true }));
      _correcting = false;
    }
  }, true);

  // ── PRODUCT PAGE ──────────────────────────────────────────────────────────
  function initProductPage() {
    if (!window._eurus_min25) return;

    var input = document.querySelector(
      'input[name="quantity"][type="number"]:not([type="hidden"])'
    );
    if (!input) return;

    input.setAttribute('min',  String(MIN));
    input.setAttribute('step', String(STEP));

    // Snap initial value
    var val = parseInt(input.value, 10);
    if (isNaN(val) || val < MIN || val % STEP !== 0) {
      input.value = MIN;
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    // Update price to reflect qty=25 on initial load
    triggerUpdatePrice(input);

    // After each button click, let Alpine run first then correct + update price
    var container = input.closest('[x-data]') || input.parentElement;
    if (container && !container._min25) {
      container._min25 = true;
      container.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (!btn) return;
        requestAnimationFrame(function () {
          var v = parseInt(input.value, 10);
          var corrected = clampToStep(isNaN(v) ? 0 : v);
          if (v !== corrected) {
            input.value = corrected;
            input.dispatchEvent(new Event('input',  { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          // Always update price after any quantity change
          triggerUpdatePrice(input);
        });
      }, false);
    }

    // Correct + update price on blur (manual keyboard input)
    if (!input._min25) {
      input._min25 = true;
      input.addEventListener('blur', function () {
        var v = parseInt(this.value, 10);
        var corrected = clampToStep(isNaN(v) ? 0 : v);
        if (v !== corrected) {
          this.value = corrected;
          this.dispatchEvent(new Event('input',  { bubbles: true }));
          this.dispatchEvent(new Event('change', { bubbles: true }));
        }
        triggerUpdatePrice(this);
      });
    }
  }

  // ── COLLECTION GRID: hidden quantity=25 for min_25 forms ─────────────────
  function initCollectionForms() {
    document.querySelectorAll(
      '[data-min25-product="true"] form[action="/cart/add"], form[data-min25-product="true"]'
    ).forEach(function (form) {
      var existing = form.querySelector('input[name="quantity"]');
      if (!existing) {
        var h = document.createElement('input');
        h.type = 'hidden'; h.name = 'quantity'; h.value = String(MIN);
        form.appendChild(h);
      } else {
        var v = parseInt(existing.value, 10);
        if (isNaN(v) || v < MIN) existing.value = String(MIN);
      }
    });
  }

  // ── SNAP existing cart inputs on load / after AJAX re-render ─────────────
  function snapCartInputs() {
    document.querySelectorAll('[data-min25="true"] input[type="number"]').forEach(function (input) {
      input.setAttribute('min', String(MIN));
      var val = parseInt(input.value, 10);
      var corrected = clampToStep(isNaN(val) ? 0 : val);
      if (val !== corrected) input.value = corrected;
    });
  }

  // ── MUTATION OBSERVER: cart drawer re-renders ─────────────────────────────
  var observer = new MutationObserver(function (mutations) {
    var found = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (
          (node.getAttribute && node.getAttribute('data-min25') === 'true') ||
          (node.querySelector  && node.querySelector('[data-min25="true"]'))
        ) found = true;
      });
    });
    if (found) setTimeout(snapCartInputs, 60);
  });

  // ── BOOT ─────────────────────────────────────────────────────────────────
  function boot() {
    snapCartInputs();
    initCollectionForms();

    initProductPage();
    document.addEventListener('alpine:initialized', function () {
      initProductPage();
      // Extra tick to let Alpine fully render price elements before updating
      setTimeout(function () {
        if (!window._eurus_min25) return;
        var input = document.querySelector('input[name="quantity"][type="number"]:not([type="hidden"])');
        if (input) triggerUpdatePrice(input);
      }, 100);
    });
    setTimeout(initProductPage, 300);

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
